import Component from './ReportStatus.vue';

export default {
  install(Vue) {
    Vue.component('BkfIconReportStatus', Component);
  },
};
